import Component from './Component';

// Attempts to load a Vimeo thumbnail as a background image.

export default class VimeoBanner extends Component {
  load() {

    // console.log('VimeoBanner loaded');

    const video_id = $("#vimeobgplayer").data('id');
    // We need a backoffice setting to enablue use of vimeo thumbnail
    const usevimeothumbnail = $("#vimeobgplayer").data('usevimeothumbnail');
    // console.log('VimeoBanner', video_id);
    if (!video_id || !usevimeothumbnail) {
      // console.error('VimeoBanner: video_id not found');
      return;
    }

    $.ajax({
      type: 'GET',
      url: 'https://vimeo.com/api/v2/video/' + video_id + '.json',
      jsonp: 'callback',
      dataType: 'json',
      success: function (data) {
        // console.log('VimeoBanner ajax success');

        const thumbnail_src = data[0].thumbnail_large;

        const bannerImgElement = document.querySelector('.banner__picture img');
        const bannerImgSource = document.querySelectorAll('.banner__picture source');

        if (bannerImgElement) {
          console.log(bannerImgElement.src);
          // let num = 0;
          bannerImgSource.forEach(source => {
            source.srcset = thumbnail_src;
            // console.log(num++);
          });
          bannerImgElement.src = thumbnail_src;
        } else {
          console.error('banner__picture element not found');
        }
      },
      error: function (xhr, status, error) {
        console.error('VimeoBanner AJAX request error:', status, error);
      }
    });
    super.load();
  }
}
